import React, { memo } from "react";
import { Grid } from "@material-ui/core";
import useStyles from "./styles";
import Promotion from "../../../../components/Promotion";
import clsx from "clsx";
import ImagesConfig from "components/ImagesConfig";
import { Images } from "config/images";

const PromotionItem = props => {
	const classes = useStyles();
	const { product } = props;

	const totalBox = Math.floor(product?.quantity / product?.maxUnitQuantity);
	const totalDetail = product?.quantity - totalBox * product?.maxUnitQuantity;

	return (
		<Grid classes={{ root: classes.root }}>
			<Promotion product={product} />
			<Grid classes={{ root: classes.borderProduct }}>
				<Grid classes={{ root: classes.img }}>
					<ImagesConfig
						image={product?.images}
						imageDefault={Images.icProductDefault}
						width={80}
						height={80}
					/>
				</Grid>
				<Grid classes={{ root: classes.body }}>
					<Grid classes={{ root: classes.bodyInfoProduct }}>
						<Grid classes={{ root: classes.nameProduct }}>
							{product?.productName}
						</Grid>
					</Grid>
					<Grid
						classes={{
							root: clsx(classes.bodyInfoProduct, classes.mt10)
						}}
					>
						<Grid classes={{ root: classes.cartType }}>
							Số lượng thùng
						</Grid>
						<Grid
							classes={{
								root: classes.priceCart
							}}
						>
							{totalBox}
						</Grid>
					</Grid>
					<Grid
						classes={{
							root: clsx(classes.bodyInfoProduct, classes.mt10)
						}}
					>
						<Grid classes={{ root: classes.cartType }}>
							Số lượng lẻ
						</Grid>
						<Grid
							classes={{
								root: classes.priceCart
							}}
						>
							{totalDetail}
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default memo(PromotionItem);
